import { apiV1 } from '~/services/api';
import { WebhookAPIType } from '~/types/Webhooks';

function editWebhook(data: WebhookAPIType) {
  return apiV1.request({
    url: `/webhooks/${data.object_id}`,
    method: 'PUT',
    data: {
      active: data.active,
      event: data.event,
      is_test: data.is_test,
      url: data.url,
    },
  });
}

function deleteWebhook(data: WebhookAPIType) {
  return apiV1.request({
    url: `/webhooks/${data.object_id}`,
    method: 'DELETE',
  });
}

function saveWebhook(data: WebhookAPIType) {
  return apiV1.request({
    url: `/webhooks/`,
    method: 'POST',
    data: {
      active: data.active,
      event: data.event,
      is_test: data.is_test,
      url: data.url,
    },
  });
}

function testWebhook(data: WebhookAPIType) {
  return apiV1.request({
    url: `/webhooks/${data.object_id}/test`,
    method: 'POST',
    data: {
      event: data.event === '*' ? 'track_updated' : data.event,
    },
  });
}

function getWebhooks() {
  return apiV1.request({
    url: '/webhooks',
  });
}

export { getWebhooks, saveWebhook, testWebhook, editWebhook, deleteWebhook };
